import React from "react";
import { Box, Container, Typography, Button, CircularProgress } from "@mui/material";

export default function InitYoloScreen({
  title,
  info,
  showLoader = false,
}) {

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f0f0fb3b",
        opacity: 1,
        px: 2,
      }}
    >
      <Container maxWidth="sm">
        <Box
          sx={{
            backgroundColor: "white",
            borderRadius: "16px",
            p: { xs: 3, sm: 5 },
            textAlign: "center",
            boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
          }}
        >
          {/* Loader */}
          {showLoader && (
            <Box sx={{ mb: 2 }}>
              <CircularProgress size={40} sx={{ color: "#3F41D1" }} />
            </Box>
          )}

          {/* Title */}
          <Typography
            sx={{
              fontSize: { xs: "20px", sm: "24px" },
              fontWeight: "bold",
              color: "#1e1e1e",
              mb: 1.5,
            }}
          >
            {title}
          </Typography>

          {/* Optional info badge */}
          {info && (
            <Box
              sx={{
                backgroundColor: "#f0f0fb",
                border: "1px solid #d0d0f0",
                borderRadius: "8px",
                px: 2,
                py: 1.5,
                mb: 3,
              }}
            >
              <Typography sx={{ fontSize: "13px", color: "#3F41D1" }}>
                {info}
              </Typography>
            </Box>
          )}
        </Box>
      </Container>
    </Box>
  );
}
